import { Switch } from "@mui/material";

interface IProps {
  checked: boolean;
  onChange: (name: string, value: boolean) => void;
  label: string;
  name: string;
}

const ToggleSwitch = ({ checked, label, name, onChange }: IProps) => {
  return (
    <div
      className="flex flex-row justify-start items-center gap-3"
      onClick={() => onChange(name, !checked)}
    >
      <div className="text-xs">{label}</div>
      <Switch checked={checked} onChange={(_, v) => onChange(name, v)} />
    </div>
  );
};

export default ToggleSwitch;
